import { FacebookLoginResponse } from './socialSignOnTypes';

/**
 *
 * @param forceRoundtrip When true, this function will call Facebook's servers. Otherwise, this function returns a cached result.
 *
 * @returns __Promise__ Resolving to Facebook's login response or rejecting with a Javascript error
 *
 * Promisified version of FacebookSDK.getLoginStatus
 *
 * @hidden
 */
export const getFacebookLoginStatus = (
  forceRoundtrip?: boolean
): Promise<FacebookLoginResponse | Error> => {
  return new Promise((resolve, reject) => {
    try {
      window.FB.getLoginStatus((response: FacebookLoginResponse) => {
        if (response) {
          resolve(response);
        } else {
          throw new Error('Failed to get a response from FB');
        }
      }, forceRoundtrip);
    } catch (e) {
      reject(e);
    }
  });
};

export default getFacebookLoginStatus;
